<template>
  <div class="popupShow" v-if="popupShowFlag">{{popupShowText}}</div>
</template>

<script>
  export default {
    name: "popup",
    data() {
      return {
        popupShowFlag: false,
        popupShowText: ''
      }
    },
    methods: {
      popupShowing(text, sec) {
        const second = sec || 3000;
        this.popupShowFlag = true;
        this.popupShowText = text;
        setTimeout(() => {
          this.popupShowFlag = false;
        }, second);
      }
    }
  }
</script>

<style scoped lang="scss">
  .popupShow {
    position: fixed;
    padding: 5px 15px;
    display: table;
    line-height: 25px;
    max-width: 345px;
    min-width: 200px;
    background-color: #000;
    opacity: 0.7;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    color: #fff;
    text-align: center;
    border-radius: 8px;
    z-index: 2001;
  }
</style>



// WEBPACK FOOTER //
// popup.vue?1366fe64